import React from 'react';
import { Stack, Typography } from '@mui/material';
import { IconCloudSolid } from '@roku-web-ui/rds-icons';

import styles from '../overlaysStyle.module.scss';

export const Unavailable = () => (
  <Stack
    data-testid="camera-overlay-unavailable"
    direction="column"
    spacing={10}
    alignItems="center"
    justifyContent="center"
  >
    <IconCloudSolid className={styles.defaultIconSize} />
    <Typography variant="h3" className={styles.textSize}>
      Camera is unavailable
    </Typography>
  </Stack>
);
